import { Injectable, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { RestService } from '../providers/rest.service';
import { ResultOutputModel } from '../models/resultOutputModel';
import { AddOrEditCheckListTaskInputModel } from '../models/AddOrEditCheckListTaskInputModel';

@Injectable()
export class OpportunityService extends RestService {

    //  delete Check List Task by id
    deleteCheckListTask(id: number, userid: number) {
        return this.GET('opportunity/deleteCheckListTask?id=' + id + "&userId=" + userid);
    } 

    addOrEditTask(addOrEditCheckListTaskInputModel: AddOrEditCheckListTaskInputModel): Observable<ResultOutputModel>{
        return this.postForEntityObject('opportunity/addOrEditCheckListTask/', addOrEditCheckListTaskInputModel);
    }
}
